/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_PdfsInputs */

const en_mobile_benefits_pdfs = /** @type {(inputs: Mobile_Benefits_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs`)
};

const es_mobile_benefits_pdfs = /** @type {(inputs: Mobile_Benefits_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs`)
};

/**
* | output |
* | --- |
* | "PDFs" |
*
* @param {Mobile_Benefits_PdfsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_pdfs = /** @type {((inputs?: Mobile_Benefits_PdfsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_PdfsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_pdfs(inputs)
	return en_mobile_benefits_pdfs(inputs)
});